import Vue from 'vue';
import ElementUI from 'element-ui';
import '@/assets/scss/base.css'
import '@/assets/scss/common.css'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/scss/index.css'
import router from './router'
import '@/router/permission'
import store from '@/store/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

// 全局挂载
import Layout from './components/Layout.vue';

import * as api from '@/api/index'

Vue.prototype.$api = api

Vue.use(ElementUI, {
    // size: 'small'
});

// 添加全局CSS变量
const style = document.createElement('style');
style.textContent = `
  :root {
    --el-input-bg-color: #f5f5f5;
  }
  
  // .el-input__inner {
  //   background-color: var(--el-input-bg-color) !important;
  // }
  
  // .el-input__inner:hover {
  //   background-color: var(--el-input-bg-color) !important;
  // }
  
  // .el-input__inner:focus {
  //   background-color: var(--el-input-bg-color) !important;
  // }
  
  /* 修复$message的z-index问题 */
  .el-message {
    z-index: 9999 !important;
  }
  
  .el-message--success {
    z-index: 9999 !important;
  }
  
  .el-message--error {
    z-index: 9999 !important;
  }
  
  .el-message--warning {
    z-index: 9999 !important;
  }
  
  .el-message--info {
    z-index: 9999 !important;
  }
  
  /* 确保消息容器在最顶层 */
  .el-message-fade-enter-active {
    z-index: 9999 !important;
  }
`;
document.head.appendChild(style);

Vue.use(VueAwesomeSwiper)
new Vue({
    el: '#app',
    store,
    router,
    render: h => h(Layout)
});
